import { Component, input, output } from '@angular/core';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'eiq-interactive-dropdown',
  templateUrl: './interactive-dropdown.component.html',
  styleUrls: ['./interactive-dropdown.component.scss', '_interactive-dropdown-theme.component.scss']
})
export class InteractiveDropdownComponent {
  order = input<number>(0);
  itemCount = input<number>();
  disableNext = input<boolean>(false);
  clicked = output<number>();

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
}
